export default {
    'home.title'                          : 'Bienvenue sur Spordle Gateway',
    'home.subtitle'                       : 'La passerelle officielle des solutions Spordle Inc.',
    'home.merchant'                       : 'Marchand',
    'home.payment'                        : 'Paiement',
    'home.vault'                          : 'Vault',
}